import {assert} from 'Asserts';

export interface BlockPosition {
  row: number;
  col: number;
}

/**
 * Swap two blocks in a 2D rows array, returning a new array with the blocks exchanged.
 *
 * Both positions must be in bounds. If both positions are the same, the original rows are returned unchanged.
 */
export default function swapBlocks<T>(
  rows: Array<Array<T>>,
  source: BlockPosition,
  target: BlockPosition
): {newRows: Array<Array<T>>; layoutChanged: boolean} {
  if (source.row === target.row && source.col === target.col) {
    return {newRows: rows, layoutChanged: false};
  }

  assert(
    source.row >= 0 && source.row < rows.length && source.col >= 0 && source.col < rows[source.row].length,
    'swapBlocks: source position out of bounds',
    {source, rowCount: rows.length}
  );
  assert(
    target.row >= 0 && target.row < rows.length && target.col >= 0 && target.col < rows[target.row].length,
    'swapBlocks: target position out of bounds',
    {target, rowCount: rows.length}
  );

  const newRows = rows.map((row) => [...row]);
  const temp = newRows[source.row][source.col];
  newRows[source.row][source.col] = newRows[target.row][target.col];
  newRows[target.row][target.col] = temp;

  return {newRows, layoutChanged: true};
}
